export const aggregateOBTMaterials = ticket => {
  let gross = 0
  let tare = 0
  const materialCommonNames = []

  const packingListsAndFinishedGoods = [...ticket.packingLists, { finishedGoods: ticket.finishedGoods }]

  packingListsAndFinishedGoods?.forEach(element => {
    element?.finishedGoods?.forEach(finishedGood => {
      gross += finishedGood?.weight?.gross || 0
      tare += finishedGood?.weight?.gross || 0
      materialCommonNames.push(finishedGood?.materialType?.commonName || '')
    })
  })

  ticket.materialWeights?.forEach(material => {
    gross += material?.gross || 0
    tare += material?.tare || 0
    materialCommonNames.push(material?.materialType?.commonName || '')
  })

  return {
    gross,
    tare,
    materialCommonNames,
  }
}

export const materialsHasTareRequiredAndMissing = (materials = []) =>
  materials.some(material => material?.materialType?.tareWeightRequired && material?.weightAndPrice?.tare === null)
